module.exports = __webpack_public_path__ + "static/media/48405682_2308752942533217_8171367720944664576_o-thumb.d716c0ab.jpg";